import { NavLink, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {activeRoute} from "../../util/helper";
import {checkPermission} from "../../util/auth";

const LeftNavComponent = () => {
  const [parentIndex, setParentIndex] = useState(null);
  const [childIndex, setSubIndex] = useState(null);

  const selectParentMenu = (index) => {
    // setParentIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const selectSubMenu = (index) => {
    setSubIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const location = useLocation()
  useEffect(() => {
    let currentRoute = activeRoute(location.pathname)

    if(!currentRoute.length)
      setParentIndex(null)

    if(currentRoute.length)
      setParentIndex(currentRoute[0])

    if(currentRoute.length > 1)
      setSubIndex(currentRoute[1])

  }, [location]);

  const redirectHandler = (event, to) => {
    if (to === location.pathname) {
      event.preventDefault();
    }
  };

  return (
    <div id="left_nav">
      <ul className="left_nav_list">
        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${!parentIndex ? 'active' : ''}`  }>
            <NavLink className="width_full"
                     end to="/"> <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/icon-new/dashboard.png" alt="" />
            </span> <span>Dashboard</span> </NavLink>
          </div>
        </li>
        {checkPermission(['PRODUCT_READ', 'PRODUCT_REVIEW_READ', 'PRODUCT_CREATE'], 'some') &&
        <li>
          <div data-toggle="accordion" data-target="#products" className={`left_f_list cursor_pointer`}
               onClick={() => selectParentMenu('products')}>
            <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/icon-new/product.png" alt=""/>
            </span> <span>Products</span>
          </div>

          <ul className={`sub_accordion first_level  ${parentIndex === 'products' ? ' current' : ''}`} id={'products'}>
            {checkPermission(['PRODUCT_READ']) && <li><NavLink end to="/products">All Products</NavLink></li> }
            {checkPermission(['PRODUCT_CREATE']) && <li><NavLink end to="/products/add">Add New Products</NavLink></li> }
            {checkPermission(['PRODUCT_REVIEW_READ']) && <li><NavLink end to="/products/reviews">Reviews</NavLink></li> }
          </ul>
        </li>
        }

        {checkPermission(['CATEGORY_READ'], 'some') &&
        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'categories' ? 'active' : ''}`}>
            <NavLink className="width_full"
                     to="/categories"> <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/icon-new/category.png" alt=""/>
            </span><span>Categories</span></NavLink>
          </div>
        </li>
        }

        {checkPermission(['CUSTOMER_READ'], 'some') &&
        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'customers' ? 'active' : ''}`}>
            <NavLink className="width_full"
                     to="/customers"> <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/icon-new/customers.png" alt=""/>
            </span>
              <span>Customers</span></NavLink>
          </div>
        </li>
        }

        {checkPermission(['ORDER_READ'], 'some') &&
        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'orders' ? 'active' : ''}`}>
            <NavLink className="width_full" end to="/orders"> <span className={'left_img'}>
            <img src="/assets/media/images/left-icon/icon-new/order.png" alt=""/>
            </span> <span>Orders</span> </NavLink>
          </div>
        </li>
        }
        {checkPermission(['INCOMPLETE_CHECKOUT_VIEW']) &&
        <li>
          <div
              className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'incomplete-checkout' ? 'active' : ''}`}>
            <NavLink className="width_full" end to="/incomplete-checkout"> <span className={'left_img'}>
            <img src="/assets/media/images/left-icon/icon-new/page.png" alt=""/>
            </span> <span>Incomplete Checkout</span> </NavLink>
          </div>
        </li>
        }
        {checkPermission(['TRANSACTIONS_VIEW']) &&
        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'transactions' ? 'active' : ''}`}>
            <NavLink className="width_full" end to="/transactions"> <span className={'left_img'}>
            <img src="/assets/media/images/left-icon/icon-new/Transaction.png" alt=""/>
            </span> <span>Transaction </span>
            </NavLink>
          </div>
        </li>
        }
        {checkPermission(['BANK_ACCOUNT_READ', 'SHIPPING_METHODS_VIEW', 'CARRIER_VIEW'], 'some') &&
        <li>
          <div data-toggle="accordion" data-target="#settings" className={`left_f_list cursor_pointer`} onClick={() => selectParentMenu('settings')}>
            <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/left-ic-7.png" alt="" />
            </span> <span>System Settings</span>
          </div>
          <ul className={`sub_accordion first_level  ${parentIndex === 'settings' ? ' current' : ''}`} id={'settings'}>
            {checkPermission(['SHIPPING_METHODS_VIEW']) && <li><NavLink end to="/settings/shipping-methods">Shipping Methods</NavLink></li> }
            {checkPermission(['CARRIER_VIEW']) &&  <li><NavLink onClick={(event) => redirectHandler(event, '/settings/couriers')} end to="/settings/carriers">Carriers</NavLink></li> }
            {/*{checkPermission(['BANK_ACCOUNT_READ']) && <li><NavLink end to="/settings/setup-bank-account">Setup Bank</NavLink></li>}*/}
          </ul>
        </li>
        }
        {checkPermission(['ROLE_READ','USER_READ'], 'some') &&
        <li>
          <div data-toggle="accordion" data-target="#user-management" className={`left_f_list cursor_pointer`}
               onClick={() => selectParentMenu('user-management')}>
            <span className={'left_img'}>
              <img src="/assets/media/images/left-icon/left-ic-8.png" alt=""/>
            </span> <span>User Management</span>
          </div>

          <ul className={`sub_accordion first_level  ${parentIndex === 'user-management' ? ' current' : ''}`}
              id={'user-management'}>
            {checkPermission(['USER_READ']) && <li><NavLink end to="/user-management/users">Users</NavLink></li> }
            {checkPermission(['ROLE_READ']) && <li><NavLink end to="/user-management/role"> Role</NavLink></li> }
          </ul>
        </li>
        }

        <li>
          <div className={`left_f_list no_arrow cursor_pointer ${parentIndex === 'coupons' ? 'active' : ''}`  }>
            <NavLink end to="/coupons"> <span className={'left_img'}><i className="fas fa-user-secret"></i> </span> <span>Coupons</span> </NavLink>
          </div>
        </li>
      </ul>
    </div>
  );
};

export default LeftNavComponent;